import NotesAndTasks from './NotesAndTasks.view';

export default NotesAndTasks;
